module.exports = __webpack_public_path__ + "assets/resstar4-1at2x.aae3de4750cf893b7816313daf3781b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar4-1at2x.png
// module id = 859
// module chunks = 0